import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";


const TurnosTelemedicinaMenu = () => {
    const navigate = useNavigate();

    const clickHandler = (e) =>{
        navigate("/turnostelemedicina",{state: {id: e.split("|")[1], name: e.split("|")[0]}});
        
    }

    
    return (
        <>
       <div class="container text-center indexContent" >
            {/*<div class="row">
                <div class="col">
                    <h1 class="titleIndicator">
                    <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/turnosdocumentacionmenu")}}/> Licencias</h1>
                </div>
    </div>*/}
    <PageTitles texto="Turnos" subtexto="Telemedicina" icono="./icon_header_turnos.svg" retorno="/turnossaludmenu"/>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                    <button className="buttonInvertedClip" onClick={()=> clickHandler("Telemedicina Clinica Medica|3605")}>Telemedicina Clinica Medica</button>
               </div> 
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonInvertedClip" onClick={()=> clickHandler("Telemedicina Pediatrica|3604")}>Telemedicina Pediatrica</button>
                </div>
                </div>
            </div>
            
       </div>
        
        </>

    );
}

export default TurnosTelemedicinaMenu;